import { getEmailRegex } from 'hb-react/shared/constants/emailRegex';
import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('Must be a valid url');
export const errorMessageWithProtocol = __(
  'URL must start with http:// or https://',
);

const emailRegex = getEmailRegex({ mailto: 'required' });

// Require http(s) in front of the url OR www.
export const standardUrlRegex =
  /((https?:\/\/(www\.)?)|www\.)[a-z0-9._-]{1,253}\.[a-z0-9]{2,63}\b\S*/gi;

const urlRegex = /(www\.)?[a-zA-Z0-9._-]{1,253}\.[a-zA-Z0-9]{2,63}/;
const pathRegex = /\b\S*/;

interface GetUrlRegexParams {
  global?: boolean;
  path?: boolean;
  protocol?: 'optional' | 'required';
}

export const getUrlRegex = ({
  protocol,
  global,
  path,
}: GetUrlRegexParams = {}) => {
  let protocolPattern = '';
  let pathPattern = '';

  if (protocol === 'required') {
    protocolPattern = 'http[s]?://';
  }

  if (protocol === 'optional') {
    protocolPattern = '(?:http[s]?://)?';
  }

  if (path) {
    pathPattern = pathRegex.source;
  }

  const pattern = `${protocolPattern}${urlRegex.source}${pathPattern}`;

  // We intentionally omitted the $ at the end of the "local" regex to match the previous behavior
  return global ? new RegExp(pattern, 'gi') : new RegExp(`^${pattern}`, 'i');
};

const validUrlRegex = getUrlRegex({ protocol: 'optional' });
const validUrlWithProtocolRegex = getUrlRegex({ protocol: 'required' });

export const validateUrlAndMailToFormat = (value, protocol) => {
  if (isValueEmpty(value)) {
    return;
  }

  if (emailRegex.test(value)) {
    return;
  }

  if (protocol && validUrlWithProtocolRegex.test(value)) {
    return;
  }

  if (!protocol && validUrlRegex.test(value)) {
    return;
  }

  return errorMessage;
};

export const validateUrlFormat = (value) => {
  if (isValueEmpty(value)) {
    return;
  }

  if (validUrlRegex.test(value)) {
    return;
  }

  return errorMessage;
};

export const validateUrlFormatWithProtocol = (value) => {
  if (isValueEmpty(value)) {
    return;
  }

  if (validUrlWithProtocolRegex.test(value)) {
    return;
  }

  return errorMessageWithProtocol;
};
